import { Component, Input, OnInit } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { DialogsService } from '../../../core/services/dialog.service';
import { CustomerReviewDAO } from '../../../core/services/dao/customerReviewDAO';
import { CustomerReviewRatingType } from 'anchor-shared/lib/model/enum/customer-review-rating-type';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-vessel-reviews',
  templateUrl: './vessel-reviews.component.html',
  styleUrls: ['./vessel-reviews.component.scss'],
})
export class VesselReviewsComponent implements OnInit {
  @Input() vesselId: number;
  @Input() vesselReviews;
  @Input() aggregateReviews;
  overallRating: number;
  isMobile: boolean;
  previewCount: number = 6;
  subs: Subscription[] = [];

  constructor(
    private customerReviewDAO: CustomerReviewDAO,
    private dialogsService: DialogsService,
    private breakpointObserver: BreakpointObserver,
  ) {
    const breakpointSub = this.breakpointObserver
      .observe(['(min-width: 960px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });
    this.subs.push(breakpointSub);
  }

  ngOnInit() {
    this.initVesselReviews();
  }

  initVesselReviews() {
    if (!this.vesselReviews) {
      const publicVesselSub = this.customerReviewDAO
        .getPublicVesselReviews(this.vesselId)
        .subscribe(({ vesselReviews, aggregateReviews }) => {
          this.vesselReviews = vesselReviews;
          this.aggregateReviews = aggregateReviews;
          this.setOverallRating();
        });
      this.subs.push(publicVesselSub);
    } else {
      this.setOverallRating();
    }
  }

  setOverallRating() {
    this.overallRating =
      this.aggregateReviews.find(
        (x) => x.ratingType === CustomerReviewRatingType.Overall,
      )?.rateAverage || 5;
  }

  viewReviewsDialog() {
    this.dialogsService.VesselReviewsDialog(
      this.vesselReviews,
      this.aggregateReviews,
      this.isMobile,
    );
  }
}
